export class SortedListItem {
    private _sequence: number | null;
    constructor() {
        this._sequence = null;
    }

    get sequence() {
        return this._sequence;
    }

    set sequence(value) {
        this._sequence = value;
    }
}
